import React, { useEffect } from 'react';
import { FuelCallout } from '@frete.com/fuel-react';
import useAmplitude from '@hooks/useAmplitude';
import { formatDateDistance } from '@utils/formatters';
import { hasOccurence } from '@utils/occurrence';
import { OccurrencePropsInterface } from './OccurrenceTypes';
import * as Styled from './OccurrenceStyles';

function Occurrence({
  reason,
  createdAt,
  id,
  journeyId,
  read,
}: OccurrencePropsInterface) {
  const { amplitudeEvent } = useAmplitude();

  useEffect(() => {
    if (hasOccurence({ createdAt, id, reason })) {
      amplitudeEvent('journey_list_map_popup_occurrence_viewed');

      window.dispatchEvent(
        new CustomEvent('mapOccurrenceViewed', {
          detail: {
            occurrenceId: id,
            journeyId,
            alreadyRead: read,
          },
        }),
      );
    }
  }, []);

  if (!hasOccurence({ createdAt, id, reason })) {
    return null;
  }

  return (
    <Styled.Wrapper>
      <FuelCallout
        message={reason}
        detail={formatDateDistance(createdAt)}
        color="orange"
        icon="alert"
        fullWidth
      />
    </Styled.Wrapper>
  );
}

export default Occurrence;
